const ADD_VISITED_VIEW = 'ADD_VISITED_VIEW'
const DEL_VISITED_VIEW = 'DEL_VISITED_VIEW'
const DEL_OTHERS_VIEWS = 'DEL_OTHERS_VIEWS'
const DEL_ALL_VIEWS = 'DEL_ALL_VIEWS'

const state = {
  visitedViews: []
}

const mutations = {
  [ADD_VISITED_VIEW](state, view) {
    if (state.visitedViews.some(v => v.path === view.path)) return
    state.visitedViews.push(
      Object.assign({}, view, {
        title: view.meta && view.meta.title ? view.meta.title : (view.name || '未命名页面')
      })
    )
  },
  [DEL_VISITED_VIEW](state, view) {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
  },
  [DEL_OTHERS_VIEWS](state, view) {
    state.visitedViews = state.visitedViews.filter(v => {
      return v.path === view.path
    })
  },
  [DEL_ALL_VIEWS](state) {
    state.visitedViews = []
  }
}

const actions = {
  addView({ commit }, view) {
    commit(ADD_VISITED_VIEW, view)
  },
  delView({ commit, state }, view) {
    return new Promise((resolve) => {
      commit(DEL_VISITED_VIEW, view)
      resolve([...state.visitedViews])
    })
  },
  delOthersViews({ commit, state }, view) {
    return new Promise((resolve) => {
      commit(DEL_OTHERS_VIEWS, view)
      resolve([...state.visitedViews])
    })
  },
  delAllViews({ commit, state }) {
    return new Promise((resolve) => {
      commit(DEL_ALL_VIEWS)
      resolve([...state.visitedViews])
    })
  }
}

const tabs = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default tabs
